import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const ChannelListBottomContainer = styled.div<{ focused?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: ${165 * Screen.widthRatio}px;
`;

export default ChannelListBottomContainer;
